module.exports = __webpack_public_path__ + "static/media/19ESCAP44.367ad6c4.jpg";